import React from 'react';
import { List, Datagrid, TextField, ReferenceField, DateField, BooleanField } from 'react-admin';
import Icon from '@material-ui/icons/DriveEta';
import CreateForm from './CreateForm';
import EditForm from './EditForm';
import ShowForm from './ShowForm';
import { ListFilter, ListActions } from './ListActions';

export const CustomerCarIcon = Icon;

export const CustomerCarList = props => (
  <List {...props} title="Customer Cars" actions={<ListActions />} filters={<ListFilter />} bulkActionButtons={false}>
    <Datagrid>
      <ReferenceField
        label="Customer"
        sortBy="users.last_name"
        source="user_id"
        reference="customers"
        allowEmpty={true}
      >
        <TextField source="last_name" />
      </ReferenceField>
      <BooleanField source="is_family_car" label="Family Car" />
      <TextField source="reg_no" />
      <DateField source="reg_date" />
      <ReferenceField
        label="Car Brand"
        sortBy="car_brands.name"
        source="car_brand_id"
        reference="brands"
        allowEmpty={true}
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Car Model"
        sortBy="car_models.name"
        source="car_model_id"
        reference="models"
        allowEmpty={true}
      >
        <TextField source="name" />
      </ReferenceField>
      <DateField source="last_service_date" label="Last Visit Date" />
      <ReferenceField
        label="Sales Consultant"
        sortBy="sa.full_name"
        source="sales_advisor_id"
        reference="sales_advisors"
        allowEmpty={true}
      >
        <TextField source="full_name" />
      </ReferenceField>
      <ReferenceField
        label="Service Consultant"
        sortBy="sc.full_name"
        source="service_consultant_id"
        reference="service_consultants"
        allowEmpty={true}
      >
        <TextField source="full_name" />
      </ReferenceField>
      <TextField source="autoline_id" label="Autoline ID" />
    </Datagrid>
  </List>
);

export const CustomerCarShow = ShowForm;

export const CustomerCarCreate = CreateForm;

export const CustomerCarEdit = EditForm;



// WEBPACK FOOTER //
// ./src/containers/CustomerCar/index.js